import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=f19a3c66&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=f19a3c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19a3c66",
  null
  
)

export default component.exports